import { formatDateTime } from "../../../users/adminUserFormatters";
import WeatherHealthBadge from "../WeatherHealthBadge";

function ResultMetric({ label, value }) {
  if (value == null || value === "") {
    return null;
  }

  return (
    <div className="weather-radar-action-result__metric">
      <span className="weather-radar-action-result__metric-label">{label}</span>
      <span>{value}</span>
    </div>
  );
}

const ACTION_LABELS = {
  bart_discovery: "Run discovery",
  bart_cache_sync: "Sync cache",
  bart_cache_cleanup: "Clear stale frames",
  radar_diagnostics_export: "Export diagnostics",
};

const WeatherRadarActionResultPanel = ({ result }) => {
  if (!result) {
    return null;
  }

  const actionLabel = ACTION_LABELS[result.action] || result.action || "Action";
  const finishedAt = result.finishedAt || result.checkedAt || result.syncedAt || result.cleanedAt;

  return (
    <div className="weather-radar-action-result panel-card" role="status" aria-live="polite">
      <div className="weather-radar-action-result__header">
        <h3 className="admin-section-title">Last action result</h3>
        {result.status ? <WeatherHealthBadge status={result.status} /> : null}
      </div>

      <p className="weather-radar-action-result__action">{actionLabel}</p>
      {result.message ? <p className="weather-radar-action-result__message">{result.message}</p> : null}

      <div className="weather-radar-action-result__metrics">
        {result.startedAt ? (
          <ResultMetric label="Started" value={formatDateTime(result.startedAt)} />
        ) : null}
        {finishedAt ? <ResultMetric label="Finished" value={formatDateTime(finishedAt)} /> : null}
        {result.discoveredFrameCount != null ? (
          <ResultMetric label="Discovered frames" value={result.discoveredFrameCount} />
        ) : null}
        {result.cachedFrameCount != null ? (
          <ResultMetric label="Cached frames" value={result.cachedFrameCount} />
        ) : null}
        {result.downloadedCount != null ? (
          <ResultMetric label="Downloaded" value={result.downloadedCount} />
        ) : null}
        {result.skippedCount != null ? (
          <ResultMetric label="Skipped" value={result.skippedCount} />
        ) : null}
        {result.deletedCount != null ? (
          <ResultMetric label="Deleted" value={result.deletedCount} />
        ) : null}
        {result.retainedCount != null ? (
          <ResultMetric label="Retained" value={result.retainedCount} />
        ) : null}
        {result.latestFrameRetained != null ? (
          <ResultMetric
            label="Latest frame retained"
            value={result.latestFrameRetained ? "Yes" : "No"}
          />
        ) : null}
      </div>

      {Array.isArray(result.errors) && result.errors.length ? (
        <div className="weather-radar-action-result__errors">
          <p className="weather-radar-action-result__errors-title">Errors</p>
          <ul>
            {result.errors.map((error, index) => (
              <li key={`${error.code || "error"}-${index}`}>
                {error.filename ? `${error.filename}: ` : ""}
                {error.message || error.code || "Unknown error"}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default WeatherRadarActionResultPanel;
